import React from 'react';
import NutritionPage from './pages/NutritionPage';

function App() {
  return (
    <div className="App">
      <NutritionPage />
    </div>
  );
}

export default App;